import { useQuery } from '@tanstack/react-query'
import { api } from './client'

/**
 * Online top-up of the Saadhan (global) wallet through Nepal Payment
 * Solutions. The API answers 501 until the gateway is configured; the wallet
 * page then keeps showing the pay-at-the-counter note only.
 */

export interface TopUpInstrument {
  code: string
  name: string
  institution: string | null
  /** NPS's BankType: MBanking, EBanking, checkoutcard, Wallet… */
  type: string | null
  logo_url: string | null
}

export interface TopUpOptions {
  min_amount: number
  max_amount: number
  wallet: 'global'
  instruments: TopUpInstrument[]
}

export type TopUpStatus = 'pending' | 'success' | 'failed' | 'expired' | 'mismatch'

export interface TopUp {
  id: number
  reference: string
  status: TopUpStatus
  amount: number
  service_charge: number | null
  total_paid: number | null
  institution: string | null
  instrument: string | null
  gateway_reference: string | null
  created_at: string | null
  completed_at: string | null
}

export const topup = {
  options: () => api.get<TopUpOptions>('/user/topups/options'),
  quote: (amount: number, instrument_code: string) =>
    api.post<{ amount: number; service_charge: number; total: number }>('/user/topups/quote', { amount, instrument_code }),
  start: (amount: number, instrument_code: string | null) =>
    api.post<TopUp & { checkout_url: string }>('/user/topups', { amount, instrument_code, return_to: 'web' }),
  get: (reference: string) => api.get<TopUp>(`/user/topups/${encodeURIComponent(reference)}`),
}

export const useTopUpOptions = () => useQuery({ queryKey: ['topup-options'], queryFn: topup.options, staleTime: 10 * 60_000, retry: false })

/** Group NPS's bank types for the picker. */
export function instrumentGroup(type: string | null): 'mobile' | 'internet' | 'card' | 'wallet' | 'other' {
  const t = (type ?? '').toLowerCase()
  if (t.includes('mbank')) return 'mobile'
  if (t.includes('ebank')) return 'internet'
  if (t.includes('card')) return 'card'
  if (t.includes('wallet')) return 'wallet'
  return 'other'
}
